import React from 'react'
import styled from 'styled-components'

const Root = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 4px;
  background-color: ${({ theme, variant }) => {
    switch (variant) {
      case 'success': return '#dcfce7'
      case 'danger': return '#fee2e2'
      case 'warning': return '#fef9c3'
      case 'info': return '#e0f2fe'
      default: return '#f1f5f9'
    }
  }};
  color: ${({ theme, variant }) => {
    switch (variant) {
      case 'success': return '#166534'
      case 'danger': return '#991b1b'
      case 'warning': return '#854d0e'
      case 'info': return '#075985'
      default: return '#475569'
    }
  }};
`

export function Badge({ children, variant = 'default', style, ...props }) {
  return (
    <Root variant={variant} style={style} {...props}>
      {children}
    </Root>
  )
}
